import React from 'react';
import styles from '../../App.module.css';
import { isAuthenticated } from '../../index';
import { FaWhatsapp } from 'react-icons/fa';

const ClienteHome = () => {
    const { userLogin, userNome } = isAuthenticated();

    // Monta a URL de redirecionamento para WhatsApp
    const whatsappNumber = '5561996011975';
    const textoMensagem = `gostaria de solicitar o meu acesso de teste ao GSCrm, meu email: ${userLogin}`;
    const whatsappURL = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodeURIComponent(textoMensagem)}`;

    return (
        <div className={styles.app}>
            {userNome
                ? `Olá, ${userNome}`
                : "Seja bem-vindo, faça o login em sua conta para acessar as funcionalidades"}

            <div className={styles.cadastroClienteContainer}
                style={{
                    marginTop: "60px",
                }}>
                {/* Insere a imagem */}
                <img
                    src="/memoji/Imagem.webp"
                    alt="Memoji"
                    style={{
                        maxWidth: "200px",
                        height: "auto",
                        display: "block",
                        marginTop: "-80px",
                    }}
                />
                <h1 className="text-1xl font-bold text-left| text-gray-900 mt-6">
                    Sem permissão.
                </h1>
                <div style={{ padding: "20px" }}>
                    Entre em contato e solicite agora mesmo sua permissão para testar a nossa plataforma. Clique no botão abaixo.
                </div>
                <a
                    href={whatsappURL}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        width: '200px',
                        backgroundColor: 'var(--corPrimaria)',
                        color: 'white',
                        padding: '10px',
                        fontSize: '1.2rem',
                        borderRadius: '20px',
                        fontWeight: '600',
                        textAlign: 'center',
                        textDecoration: 'none',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px', // espaçamento entre ícone e texto
                    }}
                >
                    {/* 2) Ícone WhatsApp usando react-icons */}
                    <FaWhatsapp size={20} />
                    Solicitar Agora
                </a>
            </div>
        </div>
    );
}

export default ClienteHome;
